import { useParams } from "react-router-dom";

const useInsuranceParams = () => {
  const params = useParams();
  const offerId = parseInt(params.documentId);
  const offerSiteId = parseInt(params.siteId);
  const documentDetailId = parseInt(params.documentDetailId);
  const documentDetailSiteId = parseInt(params.documentDetailSiteId);

  return { offerId, offerSiteId, documentDetailId, documentDetailSiteId };
};

export default useInsuranceParams;
